import { HttpResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { Confirmation } from "src/app/enums/confirmation.enum";
import { ErrorText } from "src/app/enums/error-text.enum";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ApiService } from "src/app/services/api.service";
import { ContentActionComponent } from "src/app/shared/content-action/content-action.component";

@Component({
  selector: "fury-page-list",
  templateUrl: "./page-list.component.html",
  styleUrls: ["./page-list.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  encapsulation: ViewEncapsulation.None,
})
export class PageListComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  filterValue: string = "Page";
  settingList: any = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  pageSize = 30;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  columns: any[] = [
    { name: "Name", property: "pageName", visible: true },
    { name: "Text", property: "bannerText", visible: true },
    { name: "Status", property: "isActive", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];
  constructor(
    private api: ApiService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.getList();
  }
  onFilterChange(value: any) {
    if (!this.dataSource) {
      return;
    }
    value = value.trim();
    value = value.toLowerCase();
    this.dataSource.filter = value;
  }
  getList() {
    this.api
      .get("admin/settings/page-content/get-page-content-settings")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            if (res.body.pageContentSettings?.estimate) {
              let data;
              data = res.body.pageContentSettings?.estimate;
              data.pageName = "estimate";
              this.settingList.push(data);
            }
            if (res.body.pageContentSettings?.offer) {
              let data;
              data = res.body.pageContentSettings?.offer;
              data.pageName = "offer";
              this.settingList.push(data);
            }
            if (res.body.pageContentSettings?.home) {
              let data;
              data = res.body.pageContentSettings?.home;
              data.pageName = "home";
              this.settingList.push(data);
            }
            if (res.body.pageContentSettings?.popUp) {
              let data;
              data = res.body.pageContentSettings?.popUp;
              data.pageName = "popUp";
              this.settingList.push(data);
            }
            this.dataSource = new MatTableDataSource(this.settingList);
            this.cdr.detectChanges();
            this.dataSource.paginator = this.paginator;
          } else {
            this.settingList = undefined;
          }
        },
        (err) => {}
      );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
